import { Button, FormControl, Input, useDisclosure, useToast } from "@chakra-ui/react";
import axios from "axios";
import React, { useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";
import imgc from "../student/bg_cours2.jpg";
import logo from "../student/dbs-logo.png";


function StudentInscription({ tittle, setFetchAgain }) {

	const { isOpen, onOpen, onClose } = useDisclosure()


	const toast = useToast();
	const [studentId, setStudentId] = useState("");
	const [name, setName] = useState("");
	const [dob, setDob] = useState("");
	const [nationality, setNationality] = useState("");
	const [phone, setPhone] = useState("");
	const [email, setEmail] = useState("");
	const [levels, setLevels] = useState("");
	const [group, setGroup] = useState("");
	const [reduction, setReduction] = useState("");
	const [reso, setRes] = useState("");
	const [restPayement, setRestPayement] = useState(true);
	const [picLoading, setPicLoading] = useState(false);
	const [typcour, setTypCour] = useState("");
	const [timecour, setTimeCour] = useState("");

	const [fetchLevelAgain, setFetchLevelAgain] = useState(true);
	const [levelTable, setLevelTable] = useState([]);
	const [groupTable, setGroupTable] = useState([]);
	const [etat, setEtat] = useState("true");
	const [dff, setDateEndFormation] = useState();

	const { user } = ChatState();



	const registerStudent = async () => {
		setPicLoading(true);

		if (!studentId || !name || !dob || !nationality || !phone || !email || !levels || !typcour || !timecour) {
			toast({
				title: "Veuillez remplir tous les champs",
				status: "warning",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
			setPicLoading(false);
			return;
		}

		try {
			const config = {
				headers: {
					"Content-type": "application/json",

				},
			};
			await axios.post(
				"/api/student",
				{
					studentId,
					name,
					dob,
					nationality,
					phone,
					email,
					levels,
					reduction,
					restPayement,
					reso,
					dff,
					typcour,
					timecour

				},
				config
			);


			toast({
				title: "Inscription réussie",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});

		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: error.response.data.message,
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});

		}
		onClose()
	};


	const handleOptionChange = (event) => {
		setRes(event.target.value);
	};
	const handleLevelOptionChange = (event) => {
		setLevels(event.target.value);
	};
	const handleTypCourOptionChange = (event) => {
		setTypCour(event.target.value);
	};

	const handleTimeCourOptionChange = (event) => {
		setTimeCour(event.target.value);
	};


	return <div className="relative w-[100vw] h-[100vh] py-5" style={{ backgroundImage: `url(${imgc})`, backgroundSize: 'cover' }}>



		<div className="relative max-h-[95vh] lg:w-[65%] md:w-[65%] w-[85%] z-40  m-auto  rounded-xl  shadow shadow-xl bg-white opacity-95 "  >

			<div className=" px-4 py-4 border-b flex  items-center ">
				<img className="w-16" src={logo} />
				<p className="ml-2 text-md font-bold"><span className="text-black">Deutsch</span>-<span className="text-red-600">Bildungs</span ><span className="text-yellow-300">studio</span></p>
			</div>
			<h1 className="text-center text-2xl pt-4 font-bold">PRÉ-INSCRIVEZ-VOUS !</h1>
			<div className={`${picLoading==false?'hidden' : "flex "} w-full z-20 h-[88vh] bg-white absolute top-12 flex-col items-center justify-center`}>
				<i className="fa-solid fa-circle-check text-green-500 text-5xl"></i>
				<h1 className="text-center text-2xl pt-4 font-bold">La pré-inscription a été effectuée avec succès.</h1>
			</div>
			<div className={`${picLoading==true?'hidden' : "flex "}flex-wrap mt-3 max-h-[64vh] justify-around px-4 md:px-16 lg:px-16 overflow-scroll`}>

				<FormControl mt={2} w={"300px"}>
					<Input className='w-20' id='id' placeholder='CIN' value={studentId}
						onChange={(e) => setStudentId(e.target.value)} />
				</FormControl>
				<FormControl mt={2} w={"300px"}>
					<Input id='name' placeholder='Nom et Prenom' value={name}
						onChange={(e) => setName(e.target.value)} />
				</FormControl>

				<FormControl mt={2} w={"300px"}>
					<Input placeholder='Date de naissance' id='dob' value={dob}
						onChange={(e) => setDob(e.target.value)} />
				</FormControl>

				<FormControl mt={2} w={"300px"}>
					<Input placeholder='Nationality' id='nationality' value={nationality}
						onChange={(e) => setNationality(e.target.value)} />
				</FormControl>

				<FormControl mt={2} w={"300px"}>

					<Input placeholder='Telephone' id='yearsOf' value={phone}
						onChange={(e) => setPhone(e.target.value)} />
				</FormControl>
				<FormControl mt={2} w={"300px"}>

					<Input placeholder='Email' id='yearsOf' value={email}
						onChange={(e) => setEmail(e.target.value)} />
				</FormControl>





				<FormControl mt={6} >
					<div className="px-5 border py-4">
						<p>Choisissez le niveau que vous souhaitez :</p>

						<div className="flex flex-wrap justify-around mt-4">
							<div>
								<input
									type="radio"
									id="n1"
									name="level"
									value="Niveau A1"
									checked={levels === 'Niveau A1'}
									onChange={handleLevelOptionChange}
								/>
								<p className='ml-1 inline'>Niveau A1</p>
							</div>


							<div>
								<input
									type="radio"
									id="n2"
									name="level"
									value="Niveau A2"
									checked={levels === 'Niveau A2'}
									onChange={handleLevelOptionChange}
								/>
								<p className='ml-1 inline'>Niveau A2</p>

							</div>

							<div>
								<input
									type="radio"
									id="n3"
									name="level"
									value="Niveau B1"
									checked={levels === 'Niveau B1'}
									onChange={handleLevelOptionChange}
								/>
								<p className='ml-1 inline'>Niveau B1</p>
							</div>


							<div>
								<input
									type="radio"
									id="n4"
									name="level"
									value="Niveau B2"
									checked={levels === 'Niveau B2'}
									onChange={handleLevelOptionChange}
								/>
								<p className='ml-1 inline'>Niveau B2</p>
							</div>

						</div>
					</div>

				</FormControl>


				<FormControl mt={6} >
					<div className="px-5 border py-4">
						<p>Quel type de cours préférez-vous ? :</p>

						<div className="flex flex-wrap justify-around mt-4">
							<div>
								<input
									type="radio"
									id="t1"
									name="typcour"
									value="présentiel"
									checked={typcour === 'présentiel'}
									onChange={handleTypCourOptionChange}
								/>
								<p className='ml-1 inline'>Présentiel</p>
							</div>


							<div>
								<input
									type="radio"
									id="t2"
									name="typecour"
									value="À distance"
									checked={typcour === 'À distance'}
									onChange={handleTypCourOptionChange}
								/>
								<p className='ml-1 inline'>À distance</p>

							</div>



						</div>
					</div>

				</FormControl>
				<FormControl mt={6} >
					<div className="px-5 border py-4">
						<p>Quel moment de la journée vous convient le mieux pour suivre les cours ? </p>

						<div className="flex flex-wrap justify-around mt-4">
							<div>
								<input
									type="radio"
									id="ti1"
									name="timecour"
									value="jour"
									checked={timecour === 'jour'}
									onChange={handleTimeCourOptionChange}
								/>
								<p className='ml-1 inline'>Jour</p>
							</div>


							<div>
								<input
									type="radio"
									id="ti2"
									name="timecour"
									value="soir"
									checked={timecour === 'soir'}
									onChange={handleTimeCourOptionChange}
								/>
								<p className='ml-1 inline'>Soir</p>

							</div>
							<div>
								<input
									type="radio"
									id="ti3"
									name="timecour"
									value="fin"
									checked={timecour === 'fin'}
									onChange={handleTimeCourOptionChange}
								/>
								<p className='ml-1 inline'>Fin de semaine</p>

							</div>



						</div>
					</div>

				</FormControl>
				<FormControl mt={6} >
					<div className="px-5 border py-4">


						<p className="">Pourquoi avez-vous choisi d'étudier l'allemand ?</p>
						<div className="flex flex-wrap lg:justify-around mt-4 justify-items-start">
							<div>
								<input
									type="radio"
									id="visa"
									name="raison-allemand"
									value="4"
									checked={reso === '4'}
									onChange={handleOptionChange}
								/>
								<p className='ml-1 inline'>Visa & séjour</p>
							</div>


							<div>
								<input
									type="radio"
									id="etudes"
									name="raison-allemand"
									value="3"
									checked={reso === '3'}
									onChange={handleOptionChange}
								/>
								<p className='ml-1 inline'>Études en Allemagne</p>

							</div>

							<div>
								<input
									type="radio"
									id="ausbildung"
									name="raison-allemand"
									value="2"
									checked={reso === '2'}
									onChange={handleOptionChange}
								/>
								<p className='ml-1 inline'>Ausbildung en Allemagne</p>
							</div>


							<div>
								<input
									type="radio"
									id="travail"
									name="raison-allemand"
									value="1"
									checked={reso === '1'}
									onChange={handleOptionChange}
								/>
								<p className='ml-1 inline'>Travailler en Allemagne</p>
							</div>
						</div>
					</div>


					{/* 

					<select className="w-full border p-2" defaultValue={reso !== '' ? reso : 'def'} value={reso !== '' ? reso : 'def'} onChange={(e) => { setRes(e.target.value) }}>
						<option value="def" defaultChecked disabled>Choiser le Raison de L'étude</option>
						<option value='1'>Travailler en Allemagne</option>
						<option value='2'>Ausbildung en Allemagne</option>
						<option value='3'>Études en Allemagne</option>
						<option value='4'>Visa & séjour</option>
					</select> */}

				</FormControl>


			</div>



			<Button colorScheme='blue' rounded={0} mt={9} w={'100%'} px={5}
				onClick={registerStudent}
				isLoading={picLoading}
			>
				S'inscrire
			</Button>
		</div>
		<div className="w-full h-full absolute top-0 right-0 left-0  z-10 bg-black  opacity-35">

		</div>



	</div>
}

export default StudentInscription